import { ApiFunction, ChatbotApi } from "../chatbot/towersChatbotApi";

export interface UserSummary {
    uid: string;
    userCode?: string | null;
    displayName: string;
    photoURL?: string | null;
}

export interface SendFriendRequestResponse {
    success: boolean;
    status: 'pending' | 'accepted';
    message: string;
}

export interface GeneralFriendResponse {
    success: boolean;
    message: string;
}

export interface ListFriendRequestsResponse {
    success: boolean;
    sent: UserSummary[];
    received: UserSummary[];
}

export interface ListFriendsResponse {
    success: boolean;
    friends: UserSummary[];
}

export interface SearchUsersResponse {
    success: boolean;
    results: UserSummary[];
}

export class SquadflixFriendsApi {
    static async sendFriendRequest({ targetUid }: { targetUid: string }): Promise<SendFriendRequestResponse> {
        const fn = new ApiFunction('sendFriendRequest', ChatbotApi.baseUrl);
        return fn.call({ targetUid });
    }

    static async cancelFriendRequest({ targetUid }: { targetUid: string }): Promise<GeneralFriendResponse> {
        const fn = new ApiFunction('cancelFriendRequest', ChatbotApi.baseUrl);
        return fn.call({ targetUid });
    }

    static async rejectFriendRequest({ targetUid }: { targetUid: string }): Promise<GeneralFriendResponse> {
        const fn = new ApiFunction('rejectFriendRequest', ChatbotApi.baseUrl);
        return fn.call({ targetUid });
    }

    static async acceptFriendRequest({ targetUid }: { targetUid: string }): Promise<GeneralFriendResponse> {
        const fn = new ApiFunction('acceptFriendRequest', ChatbotApi.baseUrl);
        return fn.call({ targetUid });
    }

    static async listFriendRequests(): Promise<ListFriendRequestsResponse> {
        const fn = new ApiFunction('listFriendRequests', ChatbotApi.baseUrl);
        return fn.call();
    }

    static async listFriends(): Promise<ListFriendsResponse> {
        const fn = new ApiFunction('listFriends', ChatbotApi.baseUrl);
        return fn.call();
    }

    static async removeFriend({ targetUid }: { targetUid: string }): Promise<GeneralFriendResponse> {
        const fn = new ApiFunction('removeFriend', ChatbotApi.baseUrl);
        return fn.call({ targetUid });
    }

    static async searchUsers({ query }: { query: string }): Promise<SearchUsersResponse> {
        const fn = new ApiFunction('searchUsers', ChatbotApi.baseUrl);
        return fn.call({ query });
    }
}
